import React from 'react';
import { UserTooltip } from 'motion-components';
import { LegacyTooltip } from './index';

export const RowFieldTooltips = ({ data, showLegacy = true }) => {
  return (
    <div className="d-flex flex-row-reverse mt-3 mb-0">
      {data && <UserTooltip data={data} />}
      <span className="mx-1"></span>
      {data && showLegacy && <LegacyTooltip data={data} />}
    </div>
  );
};

